import { useEffect, useState } from 'react';

// Returns `value` after it stops changing for `delay` ms. Used to keep
// keystroke-driven filter inputs from firing a fetch per character.
export function useDebounced(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
